"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lp_components_1 = require("lp-components");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const Alphaeon_Credit_Logo_png_1 = __importDefault(require("images/Alphaeon_Credit_Logo.png"));
const plan_svg_1 = __importDefault(require("images/utility-icons/plan.svg"));
const merchant_portal_components_1 = require("merchant-portal-components");
const utils_1 = require("utils");
const forms_1 = require("../forms");
const reducer_1 = require("../reducer");
function PromotionalPlanList({ sortedPlans, productTypes, handlePlanSelection, isSaleTransaction, createCalculatorPDF, currentLocation, purchaseAmount, lenderSettings, }) {
    const plansPrintRef = (0, react_1.useRef)(null);
    const handleModalSend = () => {
        setIsModalSendOpen(true);
    };
    const handleModalSendClose = () => {
        setIsModalSendOpen(false);
    };
    const handleOpenModal = () => {
        setIsModalOpen(true);
    };
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const sortedPlansFiltered = (0, react_1.useMemo)(() => {
        return sortedPlans.filter((plan) => {
            return (productTypes.includes(plan.productType ?? '') &&
                plan?.locationPlanSettings?.dashboardEnabled !== false);
        });
    }, [sortedPlans]);
    const [plansForPrinting, updatePlansForPrinting] = (0, react_1.useState)([]);
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    const [isModalSendOpen, setIsModalSendOpen] = (0, react_1.useState)(false);
    const [loadingPdf, setLoadingPdf] = (0, react_1.useState)(false);
    const [deferredPlans, setDeferredPlans] = (0, react_1.useState)([]);
    const [waivedInterestPlans, setWaivedInterestPlans] = (0, react_1.useState)([]);
    const [lowAprPlans, setLowAprPlans] = (0, react_1.useState)([]);
    const [revolvingPlans, setRevolvingPlans] = (0, react_1.useState)([]);
    const [otherPlans, setOtherPlans] = (0, react_1.useState)([]);
    const deferredAndWaivedInterestPlans = deferredPlans.concat(waivedInterestPlans);
    const handleSelectForPrint = (e) => {
        const selectedPlan = sortedPlansFiltered.find((plan) => plan.id == Number(e.target.value));
        if (selectedPlan &&
            plansForPrinting.find((addedPlan) => addedPlan.id == selectedPlan.id)) {
            updatePlansForPrinting(plansForPrinting.filter((addedPlan) => addedPlan.id !== selectedPlan.id));
        }
        else {
            selectedPlan &&
                updatePlansForPrinting([...plansForPrinting, selectedPlan]);
        }
    };
    const handleSubmit = (formValues) => {
        setLoadingPdf(true);
        createCalculatorPDF(formValues, 'pdf')
            .then((pdfWindowURL) => {
            if (pdfWindowURL instanceof Error) {
                throw new Error('PDF download and print failed');
            }
            (0, utils_1.windowOpenAndPrint)(pdfWindowURL); // Print
        })
            .catch((e) => {
            (0, utils_1.reportError)('flashError', {
                componentName: 'PromotionPlanList',
                funcName: 'createCalculatorPDF',
                errType: 'pdf',
                errURL: window.location.pathname,
                errMsg: e.message,
            }, e);
            (0, utils_1.toastError)(e.message);
        })
            .finally(() => {
            setLoadingPdf(false);
        });
    };
    const handleSubmitSend = (formValues) => {
        setLoadingPdf(true);
        createCalculatorPDF(formValues, 'json')
            .then((resp) => {
            if (resp && resp.error_code) {
                const errMsg = `Sending PDF failed - ${resp.message}`;
                (0, utils_1.reportError)('flashError', {
                    componentName: 'PromotionPlanList',
                    funcName: 'createCalculatorPDF',
                    errType: 'pdf',
                    errCode: resp.error_code,
                    errURL: window.location.pathname,
                    errMsg: errMsg,
                });
                (0, utils_1.toastError)(errMsg);
                setIsModalSendOpen(false);
                throw new Error(errMsg);
            }
            else {
                (0, utils_1.toastSuccess)(`Successfully sent PDF - ${resp.message}`);
                setIsModalSendOpen(false);
            }
        })
            .catch((e) => {
            (0, utils_1.reportError)('flashError', {
                componentName: 'PromotionPlanList',
                funcName: 'createCalculatorPDF',
                errType: 'pdf',
                errURL: window.location.pathname,
                errMsg: e.message,
            }, e);
            (0, utils_1.toastError)(e.message);
        })
            .finally(() => {
            setLoadingPdf(false);
        });
    };
    (0, react_1.useEffect)(() => {
        const deferredPlansTemp = [];
        const waivedInterestPlansTemp = [];
        const lowAprPlansTemp = [];
        const revolvingPlansTemp = [];
        const otherPlansTemp = [];
        sortedPlansFiltered.map((plan) => {
            if (plan?.name.includes('DEFERRED')) {
                deferredPlansTemp.push(plan);
            }
            else if (plan?.name.includes('LOW APR')) {
                lowAprPlansTemp.push(plan);
            }
            else if (plan?.name.includes('WAIVED INTEREST')) {
                waivedInterestPlansTemp.push(plan);
            }
            else if (plan?.name.includes('REVOLVING')) {
                revolvingPlansTemp.push(plan);
            }
            else {
                otherPlansTemp.push(plan);
            }
        });
        setDeferredPlans(deferredPlansTemp);
        setLowAprPlans(lowAprPlansTemp);
        setWaivedInterestPlans(waivedInterestPlansTemp);
        setRevolvingPlans(revolvingPlansTemp);
        setOtherPlans(otherPlansTemp);
    }, [sortedPlansFiltered]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "promotional-plans-container", children: [!isSaleTransaction && ((0, jsx_runtime_1.jsxs)("div", { className: "m-t-40 refund-request--header", children: [(0, jsx_runtime_1.jsx)(components_1.Span, { variant: "headline-small", children: "Promotional Plans" }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(lp_components_1.Button, { onClick: handleModalSend, className: `button-primary button-warn-outline ${plansForPrinting.length == 0 ? 'is-disabled' : ''}`, disabled: plansForPrinting.length == 0, children: "Send Plans" }), (0, jsx_runtime_1.jsx)(lp_components_1.Button, { onClick: handleOpenModal, className: `button-primary button-warn-outline ${plansForPrinting.length == 0 ? 'is-disabled' : ''}`, disabled: plansForPrinting.length == 0, children: "Print Plans" })] }) })] })), (0, jsx_runtime_1.jsx)(components_1.Modal, { isOpen: isModalOpen, setIsOpen: setIsModalOpen, onRequestClose: handleCloseModal, contentClassName: "calculator-modal-content", children: (0, jsx_runtime_1.jsx)(forms_1.CalculatorPrintPlansForm, { currentLocation: currentLocation, onSubmit: handleSubmit, loading: loadingPdf, plansForPrinting: plansForPrinting, purchaseAmount: purchaseAmount }) }), (0, jsx_runtime_1.jsx)(components_1.Modal, { isOpen: isModalSendOpen, setIsOpen: setIsModalSendOpen, onRequestClose: handleModalSendClose, contentClassName: "calculator-modal-content", children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(forms_1.CalculatorSendPlansForm, { currentLocation: currentLocation, onSubmit: handleSubmitSend, loading: loadingPdf, plansForPrinting: plansForPrinting, purchaseAmount: purchaseAmount }) }) }), (0, jsx_runtime_1.jsxs)("div", { id: "promo-plans-content", children: [deferredPlans.length > 0 && ((0, jsx_runtime_1.jsxs)("div", { className: "plan-section-title", children: [(0, jsx_runtime_1.jsx)("img", { src: plan_svg_1.default, alt: "plan-icon" }), (0, jsx_runtime_1.jsx)(components_1.P, { variant: "body-large", className: "mar-left-10", children: waivedInterestPlans.length > 0
                                    ? 'Deferred/Waived Interest Plans'
                                    : 'Deferred Interest Plans' })] })), deferredAndWaivedInterestPlans.map((plan) => ((0, jsx_runtime_1.jsx)(merchant_portal_components_1.PlanCard, { onCardClick: handlePlanSelection, handleSelectForPrint: (plan) => handleSelectForPrint(plan), lenderSettings: lenderSettings, plan: plan, isSaleTransaction: isSaleTransaction }, plan.id))), lowAprPlans.length > 0 && ((0, jsx_runtime_1.jsxs)("div", { className: "plan-section-title", children: [(0, jsx_runtime_1.jsx)("img", { src: plan_svg_1.default, alt: "plan-icon" }), (0, jsx_runtime_1.jsx)(components_1.P, { variant: "body-large", className: "mar-left-10", children: "Low APR Plans" })] })), lowAprPlans.map((plan) => ((0, jsx_runtime_1.jsx)(merchant_portal_components_1.PlanCard, { onCardClick: handlePlanSelection, handleSelectForPrint: (plan) => handleSelectForPrint(plan), lenderSettings: lenderSettings, plan: plan, isSaleTransaction: isSaleTransaction }, plan.id))), revolvingPlans.length > 0 && ((0, jsx_runtime_1.jsxs)("div", { className: "plan-section-title", children: [(0, jsx_runtime_1.jsx)("img", { src: plan_svg_1.default, alt: "plan-icon" }), (0, jsx_runtime_1.jsx)(components_1.P, { variant: "body-large", className: "mar-left-10", children: "Revolving Plan" })] })), revolvingPlans.map((plan) => ((0, jsx_runtime_1.jsx)(merchant_portal_components_1.PlanCard, { onCardClick: handlePlanSelection, handleSelectForPrint: (plan) => handleSelectForPrint(plan), lenderSettings: lenderSettings, plan: plan, isSaleTransaction: isSaleTransaction }, plan.id))), otherPlans.map((plan) => ((0, jsx_runtime_1.jsx)(merchant_portal_components_1.PlanCard, { onCardClick: handlePlanSelection, handleSelectForPrint: (plan) => handleSelectForPrint(plan), lenderSettings: lenderSettings, plan: plan, isSaleTransaction: isSaleTransaction }, plan.id)))] }), (0, jsx_runtime_1.jsx)("div", { style: { display: 'none' }, children: (0, jsx_runtime_1.jsxs)("div", { id: "plans-content-to-print", ref: plansPrintRef, children: [(0, jsx_runtime_1.jsx)("div", { className: "page-header", children: (0, jsx_runtime_1.jsx)("img", { src: Alphaeon_Credit_Logo_png_1.default, className: "logo", alt: "Logo" }) }), plansForPrinting.map((plan, idx) => ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: "page-break" }), (0, jsx_runtime_1.jsx)(merchant_portal_components_1.PlanCard, { onCardClick: handlePlanSelection, handleSelectForPrint: (plan) => handleSelectForPrint(plan), lenderSettings: lenderSettings, plan: plan, isSaleTransaction: isSaleTransaction, forPrint: true }, plan.id)] }, `plan-print-item-${idx}`)))] }) })] }));
}
function mapStateToProps(state) {
    return {
        currentLocation: reducer_1.selectors.currentLocation(state),
    };
}
const mapApiAuthToProps = {
    createCalculatorPDF: apiActions.createCalculatorPDF,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(PromotionalPlanList);
